import { FaTimes } from "react-icons/fa";
import "./PopUp.css";

export default function (props) {
  return (
    <div className="pop-up-container">
      <div className="pop-up-header">
        <FaTimes
          onClick={() => props.handleSubmit()}
          className="pop-up-header-x"
        />
        <h2>{props.title}</h2>
        {props.description && <p>{props.description}</p>}
      </div>
      {props.children}
    </div>
  );
}
